import React from 'react';

function CommandType() {
  return <div>-</div>;
}

export default CommandType;



// WEBPACK FOOTER //
// ./src/components/CommandType.jsx